import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Role information", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Role", -1)
const _hoisted_6 = {
  key: 0,
  class: "bg-gray-300 h-px w-full my-8"
}
const _hoisted_7 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Job (Optional if you want to pre-load values)", -1)
const _hoisted_10 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Name", -1)
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Department", -1)
const _hoisted_15 = { class: "flex flex-col mt-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Responsibilities", -1)
const _hoisted_17 = { class: "flex flex-col mt-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Requirements", -1)
const _hoisted_19 = { class: "flex flex-col mt-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Benefits", -1)
const _hoisted_21 = ["disabled", "onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue", "disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_27 = { class: "mr-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "bg-gray-300 h-px w-full my-8"
}
const _hoisted_32 = {
  key: 2,
  class: "flex flex-row items-center justify-end"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Bullets = _resolveComponent("Bullets")!
  const _component_NewCurrencyField = _resolveComponent("NewCurrencyField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.hasRole)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_SelectDropdown, {
              modelValue: _ctx.position_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.position_id) = $event)),
              options: _ctx.positionOptions,
              label: "Roles...",
              name: "position_id"
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasRole)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isNew)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_SelectDropdown, {
              modelValue: _ctx.job_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.job_id) = $event)),
              options: _ctx.jobs,
              label: "Job...",
              name: "job_id"
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_TextField, {
          disabled: !_ctx.isNew,
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
          name: "name",
          label: "Name..."
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_SelectDropdown, {
          disabled: !_ctx.isNew,
          modelValue: _ctx.department,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.department) = $event)),
          options: _ctx.departmentOptions,
          name: "department",
          label: "Department..."
        }, null, 8, ["disabled", "modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode(_component_Bullets, {
        disabled: !_ctx.isNew,
        modelValue: _ctx.responsibilities,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.responsibilities) = $event)),
        name: "responsibilities",
        placeholder: "Responsibilities..."
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_Bullets, {
        disabled: !_ctx.isNew,
        modelValue: _ctx.requirements,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requirements) = $event)),
        name: "requirements",
        placeholder: "Requirements..."
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["flex flex-row", { 'mt-4': i > 0 }])
        }, [
          _withDirectives(_createElementVNode("input", {
            disabled: !_ctx.isNew,
            "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].name) = $event),
            placeholder: "Name",
            type: "text",
            class: "bg-background rounded px-4 py-5 focus:outline-none disabled:cursor-not-allowed mr-4"
          }, null, 8, _hoisted_21), [
            [_vModelText, _ctx.benefits[i].name]
          ]),
          (_openBlock(), _createBlock(_component_NewCurrencyField, {
            disabled: !_ctx.isNew,
            modelValue: _ctx.benefits[i].value,
            "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].value) = $event),
            name: `benefits-${i}-value`,
            label: "Amount",
            key: _ctx.refreshCounterChange
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "name"])),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].currency) = $event),
            disabled: !_ctx.isNew,
            class: "bg-background py-5 px-3 rounded ml-4 disabled:cursor-not-allowed"
          }, _hoisted_25, 8, _hoisted_22), [
            [_vModelSelect, _ctx.benefits[i].currency]
          ])
        ], 2))
      }), 128)),
      (_ctx.isNew)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newBenefitName) = $event)),
                placeholder: "New item",
                type: "text",
                class: "bg-background rounded px-4 py-5 focus:outline-none"
              }, null, 512), [
                [_vModelText, _ctx.newBenefitName]
              ])
            ]),
            (_openBlock(), _createBlock(_component_NewCurrencyField, {
              modelValue: _ctx.newBenefitAmount,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newBenefitAmount) = $event)),
              name: "newBenefitAmount",
              label: "Amount",
              key: _ctx.refreshCounterV
            }, null, 8, ["modelValue"])),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newBenefitCurrency) = $event)),
              class: "bg-background py-5 px-3 rounded"
            }, _hoisted_30, 512), [
              [_vModelSelect, _ctx.newBenefitCurrency]
            ]),
            _createElementVNode("button", {
              class: "btn-filled-sm ml-4",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addBenefit && _ctx.addBenefit(...args)))
            }, " Add benefit ")
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasRole)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31))
      : _createCommentVNode("", true),
    (!_ctx.hasRole)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
            class: _normalizeClass({
          'btn-filled-lg': !_ctx.loading,
          'btn-filled-lg-loading': _ctx.loading,
        })
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Loading..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_34, "Save"))
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}